import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PAGES } from '../../constants/route.constants';
import { UserService } from '../../services/user/user.service';
import { debounceTime, filter } from 'rxjs';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  @Input() isMenuCollapsed: boolean = true;
  @Output() menuCollapsedFromDocumentEvent = new EventEmitter(this.isMenuCollapsed);
  public pages = PAGES;
  public clientId!: string;
  isPowerBILinkDisabled: boolean = true;
  isDashboardLinkDisabled: boolean = true;

  constructor(
    public userServiceRef: UserService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.clientId = this.route.snapshot.paramMap.get('id') || '';
    this.checkCurrentRoute();
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd), debounceTime(500))
    .subscribe(() => {      
      this.checkCurrentRoute();
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    console.log('Clicked on:', target);
    const menu = document.getElementById('vertical-navigation-menu');
    const headerButton = document.getElementById('header-btn');
    if (menu && !menu.contains(target) && headerButton && !headerButton.contains(target)) {
      console.log('Clicked outside menu and header button');
      this.isMenuCollapsed = true;
      this.menuCollapsedFromDocumentEvent.emit(this.isMenuCollapsed);
    }
  }

  private checkCurrentRoute(): void {
    const currentRoute = this.router.url;
    console.log(currentRoute);
    if (currentRoute !== '/'+this.pages.LANDING) {      
      // this.clientId = this.route.snapshot.paramMap.get('id') || '';
      this.route.firstChild?.params.subscribe(params => {
        this.clientId = params['id'];
        console.log('Route parameter ID:', this.clientId);
      });
      // this.route.firstChild?.url.subscribe(urlSegments => {
      //   this.clientId = urlSegments[1]?.path || '';
      //   console.log('Route url ID:', this.clientId);
      // });
      this.isDashboardLinkDisabled = false;
      this.isPowerBILinkDisabled = false;
    }else{
      this.isDashboardLinkDisabled = true;
      this.isPowerBILinkDisabled = true;
    }
  }
}
